import Swiper, { Navigation, Thumbs, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import { $Q, $Qll } from '../utils/querySelector';
import { RenderElements } from '../utils/renderElement';

class Section360 {
  constructor() {
    this.sec360 = $Q('.sec-360');
    this.renderElements = new RenderElements().renderTextNodes;

    this.sec360 && this._init();
  }
  /**
   * Initialize reviews feature
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _init() {
    this._initSec360SliderThumbs();
    this._initSec360Slider();
    this._init360Component();
  }

  /**
   * Initialize 360 thumbnails slider with swiper slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initSec360SliderThumbs() {
    this.slideThumbnails = new Swiper('.js-360-thumb-slider', {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 16,
      watchSlidesProgress: true,
      navigation: {
        nextEl: `.swiper-button-next.swiper-thumb-slider-button`,
        prevEl: `.swiper-button-prev.swiper-thumb-slider-button`,
      },
      breakpoints: {
        375: {
          slidesPerView: 5,
        },
        520: {
          slidesPerView: 6,
        },
        992: {
          slidesPerView: 8,
        },
        1200: {
          slidesPerView: 10,
        },
        1440: {
          slidesPerView: 13,
        },
      },
    });
  }

  /**
   * Initialize 360 main slider with swiper slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initSec360Slider() {
    this.slideMain = new Swiper('.js-360-main-slider', {
      modules: [Thumbs],
      slidesPerView: 1,
      thumbs: {
        swiper: this.slideThumbnails,
      },
      on: {
        slideChange: this._render360ImageComponent.bind(this),
      },
    });
  }

  /**
   * Render first 360 image component when loaded the DOM
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _init360Component() {
    $Qll('.js-image-360-slide').forEach((el) => {
      if (el.classList.contains('swiper-slide-active')) {
        const currentElement = $Q('.js-image-360-wrapper', el);

        this.renderElements(
          currentElement,
          this.component360image(currentElement.dataset.image360)
        );
        // Call client snippet to render 360 image
        setTimeout(() => {
          widget360();
        }, 0);
      }
    });
  }

  /**
   * Created string 360 image component ready to render
   * @param {String} link_image - Link of 360 iframe image
   * @returns {String} 360 image component
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  component360image(link_image) {
    return `
      <div class="js-image-360-component">
        <blockquote data-width="500" data-height="375" class="ricoh-theta-spherical-image" >
          <a href="${link_image}" target="_blank">
          </a>
        </blockquote>
      </div>
    `;
  }

  /**
   * Callback of slideChange event of the SwiperJS
   * Get previous and current active node slide
   * Render 360 image component in the slide active.
   * Remove previous 360 image component
   * @param {Object} - Swiper object.
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _render360ImageComponent(swiper) {
    const slideActiveWrapper = $Q(
      '.js-image-360-wrapper',
      swiper.slides[swiper.activeIndex]
    );
    const slidePreviousWrapper = $Q(
      '.js-image-360-component',
      swiper.slides[swiper.previousIndex]
    );

    if (!slideActiveWrapper.children.length) {
      this.renderElements(
        slideActiveWrapper,
        this.component360image(slideActiveWrapper.dataset.image360)
      );
      // Call client snippet to render 360 image
      this.removeSlide(slidePreviousWrapper);
      widget360();
    }
  }

  /**
   * Remove element HTML
   * @param {Node} slide - Node to remove
   */
  removeSlide(slide) {
    slide.remove();
  }
}

export { Section360 };
